import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { getFormValues } from "redux-form";

import Content from "../common/template/content";
import ContentCard from "../common/template/contentCard";
import ContentCardHeader from "../common/template/contentCardHeader";
import ContentCardBody from "../common/template/contentCardBody";
import Row from "../common/layout/row";
import Grid from "../common/layout/grid";
import Table from "../common/table/table";
import THead from "../common/table/tHead";
import NewTr from "../common/table/newTr";
import Th from "../common/table/th";
import TBody from "../common/table/tBody";
import Td from "../common/table/td";
import Button from "../common/button/button";
import Form from "./consumoIntegracaoForm";
import Select from "../common/form/select";
import { adicionarReticencias } from "../utils/adicionarReticencias";
import {
    setModoTela,
    initForm,
    salvar,
    excluir,
    setFiltro,
    getLista,
    getListaCliente,
    getListaUnidadeConsumidora,
    getListaConsumoIntegracaoTipos,
    getListaOrigemDadosTensao,
} from "./consumoIntegracaoActions";
import { Loading } from "../common/loading/loading";
import { LabelSelectUcIconeGestor } from "../common/form/LabelSelectUcIconeGestor";
import { ModalGestorConcessonaria } from "../analise/components/ModalGestorConcessionaria";

class ConsumoIntegracao extends Component {
    state = {
        listaInicial: [],
        exibirModalGestorConcessionaria: false,
        itemSelecionado: null,
    };
    componentWillMount() {
        this.props.getListaCliente();
        this.props.getListaUnidadeConsumidora();
        this.props.getListaConsumoIntegracaoTipos();
        this.props.getListaOrigemDadosTensao();
        this.props.getLista();
    }

    componentDidUpdate() {
        if (!this.state.listaInicial.length && this.props.lista.length) {
            this.setState({ listaInicial: [...this.props.lista] });
        }
    }

    render() {
        //Sem acesso
        if (!this.props.usuarioLogado || this.props.usuarioLogado.acesso_cliente) {
            return <div />;
        }

        return (
            <div>
                {this.props.aguardando ? <Loading /> : null}

                <Content>
                    {this.props.modoTela === "visualizacao" ? <Form visualizar onSubmit={() => {}} /> : null}
                    {this.props.modoTela === "cadastro" ? <Form onSubmit={this.props.salvar} /> : null}
                    {this.props.modoTela === "exclusao" ? <Form excluir onSubmit={this.props.excluir} /> : null}
                    {this.props.modoTela === "lista" ? this.lista() : null}
                </Content>
            </div>
        );
    }

    lista() {
        return (
            <ContentCard>
                <ModalGestorConcessonaria
                    visible={this.state.exibirModalGestorConcessionaria && this.state.itemSelecionado && this.state.itemSelecionado.gestor_concessionaria_energia}
                    itemSelecionado={this.state.itemSelecionado}
                    handleClose={() => this.setState({ ...this.state, exibirModalGestorConcessionaria: false, itemSelecionado: null })}
                />
                <ContentCardHeader>
                    <Row>
                        <Grid cols="6 6 4 2">
                            <Button
                                text="Adicionar"
                                type={"success"}
                                icon={"fa fa-plus"}
                                // REGRA DE PERMISSÃO REFLETIDA EM backend/app/domain/permissao/consumoIntegracao.js (incluir, editar, excluir) e nos endpoints POST, PUT e DELETE /api/consumoIntegracao
                                disabled={!this.props.usuarioLogado.acesso_monitoramento_consumo_editar}
                                event={() => {
                                    this.props.setModoTela("cadastro", { medidores: [] });
                                    this.props.initForm({ medidores: [] });
                                }}
                            />
                        </Grid>
                    </Row>
                </ContentCardHeader>
                <ContentCardBody>
                    <Row>
                        <Select
                            name="id_cliente"
                            options={this.props.listaCliente.filter((cliente) => this.state.listaInicial.find((ci) => ci.id_cliente == cliente.id))}
                            label="Cliente"
                            cols="12 6 4"
                            placeholder="Selecione o Cliente"
                            value={this.props.filtro.id_cliente}
                            onChange={(value) => {
                                this.props.setFiltro({
                                    ...this.props.filtro,
                                    id_cliente: value,
                                });
                                this.props.getLista();
                            }}
                        />
                        <Select
                            name="id_unidade_consumidora"
                            options={this.props.listaUnidadeConsumidora.filter((uc) => {
                                const filtroCliente = !this.props.filtro.id_cliente || this.props.filtro.id_cliente == uc.id_cliente;
                                const estaNaLista = this.props.lista.find((item) => item.id_unidade_consumidora == uc.id);
                                return filtroCliente && estaNaLista;
                            })}
                            label={
                                <LabelSelectUcIconeGestor
                                    filtro={this.props.filtro}
                                    listaUnidadeConsumidora={this.props.listaUnidadeConsumidora}
                                    setExibirModal={(ucFiltro) =>
                                        this.setState({
                                            ...this.state,
                                            exibirModalGestorConcessionaria: true,
                                            itemSelecionado: ucFiltro,
                                        })
                                    }
                                />
                            }
                            cols="12 6 4"
                            placeholder="Selecione a UC"
                            value={this.props.filtro.id_unidade_consumidora}
                            onChange={(value) => {
                                this.props.setFiltro({
                                    ...this.props.filtro,
                                    id_unidade_consumidora: value,
                                });
                                this.props.getLista();
                            }}
                        />
                    </Row>
                    <Table responsive>
                        <THead>
                            <NewTr backgroundColorTr={"#FFFFFF"} backgroundColorTd={"#F5F5F5"}>
                                <Th sticky>Cliente</Th>
                                <Th sticky>UC</Th>
                                <Th sticky>Tipo</Th>
                                <Th sticky>Usuário</Th>
                                <Th sticky>Senha</Th>
                            </NewTr>
                        </THead>
                        <TBody>
                            {this.props.lista.map((item) => {
                                const itemFormatado = {
                                    ...item,
                                    constante_medidor: String(item.constante_medidor).replace(".", ","),
                                };
                                return (
                                    <NewTr
                                        key={item.id}
                                        backgroundColorTr={"#FFFFFF"}
                                        backgroundColorTd={"#F5F5F5"}
                                        botoes={[
                                            {
                                                type: "primary",
                                                icon: "fas fa-eye",
                                                disabled: !this.props.usuarioLogado.acesso_monitoramento_consumo_visualizar,
                                                event: () => {
                                                    this.props.setModoTela("visualizacao", itemFormatado);
                                                    this.props.initForm(itemFormatado);
                                                },
                                            },
                                            {
                                                type: "warning",
                                                icon: "fas fa-pencil-alt",
                                                // REGRA DE PERMISSÃO REFLETIDA EM backend/app/domain/permissao/consumoIntegracao.js (editar, excluir) e nos endpoints PUT e DELETE /api/consumoIntegracao
                                                disabled: !this.props.usuarioLogado.acesso_monitoramento_consumo_editar || item.bloquearEdicaoUsuarioImplantacao,
                                                event: () => {
                                                    this.props.setModoTela("cadastro", itemFormatado);
                                                    this.props.initForm(itemFormatado);
                                                },
                                            },
                                            {
                                                type: "danger",
                                                icon: "fas fa-trash-alt",
                                                // REGRA DE PERMISSÃO REFLETIDA EM backend/app/domain/permissao/consumoIntegracao.js (editar, excluir) e nos endpoints PUT e DELETE /api/consumoIntegracao
                                                disabled: !this.props.usuarioLogado.acesso_monitoramento_consumo_editar || item.bloquearEdicaoUsuarioImplantacao,
                                                event: () => {
                                                    this.props.setModoTela("exclusao", itemFormatado);
                                                    this.props.initForm(itemFormatado);
                                                },
                                            },
                                        ]}
                                    >
                                        <Td maxWidth={200}>{item.nome_cliente}</Td>
                                        <Td maxWidth={230} paddingRight={10}>
                                            {item.nome_unidade_consumidora}
                                        </Td>
                                        <Td>{item.nome_consumo_integracao_tipo}</Td>
                                        <Td title={item.usuario}>{item.usuario ? adicionarReticencias(item.usuario) : " - "}</Td>
                                        <Td>{item.senha || " - "}</Td>
                                    </NewTr>
                                );
                            })}
                        </TBody>
                    </Table>
                </ContentCardBody>
            </ContentCard>
        );
    }
}

const mapStateToProps = (state) => ({
    sessao: state.auth.usuario,
    usuarioLogado: state.auth.usuarioLogado,
    modoTela: state.consumoIntegracao.modoTela,
    formularioValues: getFormValues("consumoIntegracaoForm")(state),
    aguardando: state.consumoIntegracao.aguardando,
    filtro: state.consumoIntegracao.filtro,
    lista: state.consumoIntegracao.lista,
    listaCliente: state.consumoIntegracao.listaCliente,
    listaUnidadeConsumidora: state.consumoIntegracao.listaUnidadeConsumidora,
});
const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            setModoTela,
            initForm,
            setFiltro,
            salvar,
            excluir,
            getLista,
            getListaCliente,
            getListaUnidadeConsumidora,
            getListaConsumoIntegracaoTipos,
            getListaOrigemDadosTensao,
        },
        dispatch
    );
export default connect(mapStateToProps, mapDispatchToProps)(ConsumoIntegracao);
